module.exports = __webpack_public_path__ + "img/person-dash.2e10b073.svg";